import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';

import { TakeActionDropdownData } from './TakeActionDropdownData';

export const takeActionDropdownDataEs: TakeActionDropdownData = {
  triggerText: 'Actúa',
  triggerHref: getMainVolopsSearchRoutePath({ lang: 'es' }),
  search: {
    title: 'Encuentra',
    items: [
      {
        type: 'volop',
        icon: 'hand',
        title: 'Voluntariado',
        href: getMainVolopsSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'event',
        icon: 'star-calendar',
        title: 'Asiste a un Evento',
        href: getMainVolopsSearchRoutePath({
          lang: 'es',
          filters: {
            type: 'VOLOP',
            actionType: ['EVENT'],
          },
        }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        image: 'illustrations/announce-illustration.svg',
        title: 'Súmate a Imagina, Conecta, Actúa',
        description:
          'Connect with a member of our team for one-on-one sessions where you’ll collaboratively develop your action plan.',
        href: '/es/imagina-conecta-actua',
      },
      {
        image: 'illustrations/article-illustration.svg',
        title: 'Centro de Recursos para Recaudación de Fondos',
        description:
          'Consejos prácticos que te facilitarán la busca de recursos para tu organización o proyecto.',
        href: '/es/recursos-recaudacion-fondos',
      },
    ],
  },
};
